<div class="loginWrapper ">
  <div class="login_Container overflow-hidden">
    <div class="loginSlider">
      <div class="login_slider_inner">
        <img *ngIf="currentStep === 1 || currentStep === 5 || currentStep === 6" src="assets/images/CreateAccout.png" alt="Create Account" style="width: 100%; height: 100vh; object-fit: contain; background-color: #000086; display: block;">
        <img *ngIf="currentStep === 2" src="assets/images/EmailOtp.png" alt="Email OTP" style="width: 100%; height: 100vh; object-fit: contain; background-color: #000086; display: block;">
        <img *ngIf="currentStep === 3" src="assets/images/PhoneNumber.png" alt="Phone Number" style="width: 100%; height: 100vh; object-fit: contain; background-color: #000086; display: block;">
        <img *ngIf="currentStep === 4" src="assets/images/PhoneOtp.png" alt="Phone OTP" style="width: 100%; height: 100vh; object-fit: contain; background-color: #000086; display: block;">
      </div>
    </div>
    <form [formGroup]="signupForm" class="w-full lg:h-screen overflow-y-auto">
      <div class="w-full flex flex-column gap-4 p-6">

        <!-- Screen 1: Email Input -->
        <div *ngIf="currentStep === 1" class="w-full flex flex-column gap-4">
          <div class="logo mb-4">
            <img src="assets/images/logo.svg" alt="GradPilots" class="mx-auto" style="max-width: 150px;">
          </div>

       

          <div class="w-full flex flex-column gap-2">
            <label for="email" class="font-bold text-black">Email Address</label>
            <p-inputGroup>
              <p-inputGroupAddon>
                <i class="pi pi-envelope text-gray-500"></i>
              </p-inputGroupAddon>
              <input type="email" id="email" formControlName="email" class="w-full inputstyle"
                placeholder="you@example.com"
                [class.error]="signupForm.get('email')?.invalid && signupForm.get('email')?.touched">
            </p-inputGroup>
          </div>

          <div class="w-full mt-2">
            <p-button label="Verify Email" class="w-full sub_style" [loading]="isEmailLoading"
              [disabled]="signupForm.get('email')?.invalid || isEmailLoading" (onClick)="validateEmail()" />
          </div>

          <div class="w-full">
            <p-divider layout="horizontal" [align]="'center'">
              <b class="text-gray-400">OR</b>
            </p-divider>
          </div>

          <div class="w-full flex flex-column gap-3">
            <app-social-login loginType='signUp' class="w-full"></app-social-login>
          </div>

          <p class="text-center mt-4">
            Already have an account?
            <a routerLink="/signin" class="hover:underline" style="color: #000086; font-weight: 600;">Sign In</a>
          </p>
        </div>

        <!-- OTP Verification (Email) -->
        <div *ngIf="currentStep === 2" class="w-full flex flex-column gap-4 text-center">
          <div class="logo mb-4">
            <img src="assets/images/logo.svg" alt="GradPilots" class="mx-auto" style="max-width: 150px;">
          </div>

          <h2 class="text-2xl font-bold">OTP Verification</h2>
          <p class="text-gray-500">Enter OTP code sent to {{signupForm.get('email')?.value}}</p>

          <div class="w-full flex justify-content-center my-4">
            <p-inputOtp formControlName="emailOTP" [length]="6" [mask]="false" />
          </div>

          <div class="w-full">
            <p class="text-gray-500 mb-3">Didn't receive OTP Code?</p>
            <div class="flex align-items-center justify-content-center gap-2">
              <i class="pi pi-clock text-gray-400"></i>
              <a href="javascript:void(0)" *ngIf="emailCanResend" (click)="resendEmailOTP($event)"
                class="hover:underline" style="color: #000086; font-weight: 600;">Resend OTP</a>
              <span *ngIf="!emailCanResend" class="text-gray-400">Resend OTP ({{emailOTPTimer}}s)</span>
            </div>
          </div>

          <div class="w-full ">
            <p-button label="Verify and Proceed" class="w-full sub_style" [loading]="isEmailOtpLoading"
              [disabled]="signupForm.get('emailOTP')?.invalid || isEmailOtpLoading" (onClick)="verifyEmailOTP()" />
          </div>

          <div class="w-full text-center mt-3">
            <a href="javascript:void(0)" (click)="previousStep()" style="color: #2F2F9B; font-weight: 600; text-decoration: none;">Back</a>
          </div>

        </div>

        <!-- Screen 3: Mobile Number -->
        <div *ngIf="currentStep === 3" class="w-full flex flex-column gap-4">
          <div class="logo mb-4">
            <img src="assets/images/logo.svg" alt="GradPilots" class="mx-auto" style="max-width: 150px;">
          </div>

      
          <div class="w-full flex flex-column gap-2">
            <label for="phoneNumber" class="font-bold text-black">Mobile Number</label>
            <p-inputGroup>
              <p-inputGroupAddon>
                <i class="pi pi-phone text-gray-500"></i>
              </p-inputGroupAddon>
              <input type="tel" formControlName="phoneNumber" class="phone-input inputstyle"
                placeholder="Enter phone number" [maxlength]="maxPhoneLength" (input)="onPhoneNumberInput($event)"
                [class.error]="signupForm.get('phoneNumber')?.invalid && signupForm.get('phoneNumber')?.touched">
            </p-inputGroup>
          </div>

          <div class="w-full mt-4">
            <p-button label="Verify Mobile" class="w-full sub_style" [loading]="isPhoneLoading"
              [disabled]="signupForm.get('phoneNumber')?.invalid || signupForm.get('countryCode')?.invalid || isPhoneLoading"
              (onClick)="validatePhone()" />
          </div>

        </div>

        <!-- Screen 4: OTP Verification (Mobile) -->
        <div *ngIf="currentStep === 4" class="w-full flex flex-column gap-4 text-center">
          <div class="logo mb-4">
            <img src="assets/images/logo.svg" alt="GradPilots" class="mx-auto" style="max-width: 150px;">
          </div>

          <h2 class="text-2xl font-bold">OTP Verification</h2>
          <p class="text-gray-500">Enter OTP code sent to
            {{signupForm.get('phoneNumber')?.value}}</p>

          <div class="w-full flex justify-content-center my-4">
            <p-inputOtp formControlName="phoneOTP" [length]="6" [mask]="false" />
          </div>

          <div class="w-full">
            <p class="text-gray-500 mb-3">Didn't receive OTP Code?</p>
            <div class="flex align-items-center justify-content-center gap-2">
              <i class="pi pi-clock text-gray-400"></i>
              <a href="javascript:void(0)" *ngIf="phoneCanResend" (click)="resendPhoneOTP($event)"
                class="text-blue-700 font-bold hover:underline">Resend OTP</a>
              <span *ngIf="!phoneCanResend" class="text-gray-400">Resend OTP ({{phoneOTPTimer}}s)</span>
            </div>
          </div>

          <div class="w-full">
            <p-button label="Verify and Proceed" class="w-full sub_style" [loading]="isPhoneOtpLoading"
              [disabled]="signupForm.get('phoneOTP')?.invalid || isPhoneOtpLoading" (onClick)="verifyPhoneOTP()" />
          </div>

          <div class="w-full text-center mt-3">
            <a href="javascript:void(0)" (click)="previousStep()" style="color: #2F2F9B; font-weight: 600; text-decoration: none;">Back</a>
          </div>

        </div>

        <!-- Screen 5: Password Setup -->
        <div *ngIf="currentStep === 5" class="w-full flex flex-column gap-4">
          <div class="logo mb-4">
            <img src="assets/images/logo.svg" alt="GradPilots" class="mx-auto" style="max-width: 150px;">
          </div>

          

          <div class="w-full flex flex-column gap-2">
            <label for="password" class="font-bold text-black">Password</label>
            <p-inputGroup>
              <p-inputGroupAddon>
                <i class="pi pi-lock text-gray-500"></i>
              </p-inputGroupAddon>
              <p-password formControlName="password" placeholder="Enter your password" [toggleMask]="true"
                styleClass="w-full" inputStyleClass="w-full inputstyle">
              </p-password>
            </p-inputGroup>
          </div>

          <div class="w-full flex flex-column gap-2">
            <label for="confirmPassword" class="font-bold text-black">Confirm Password</label>
            <p-inputGroup>
              <p-inputGroupAddon>
                <i class="pi pi-lock text-gray-500"></i>
              </p-inputGroupAddon>
              <p-password formControlName="confirmPassword" placeholder="Confirm your password" [toggleMask]="true"
                [feedback]="false" styleClass="w-full" inputStyleClass="w-full inputstyle">
              </p-password>
            </p-inputGroup>
            <small class="text-red-500"
              *ngIf="signupForm.get('confirmPassword')?.errors?.['passwordMismatch'] && signupForm.get('confirmPassword')?.touched">
              Passwords do not match
            </small>
          </div>

          <div class="w-full mt-4">
            <p-button label="Continue" class="w-full sub_style"
              [disabled]="signupForm.get('password')?.invalid || signupForm.get('confirmPassword')?.invalid"
              (onClick)="nextStep()" />
          </div>

        </div>

        <!-- Screen 6: Hear About Us -->
        <div *ngIf="currentStep === 6" class="w-full flex flex-column gap-4">
          <div class="logo mb-4">
            <img src="assets/images/logo.svg" alt="GradPilots" class="mx-auto" style="max-width: 150px;">
          </div>

          <div class="text-center mb-2">
            <h2 class="text-2xl font-bold">How did you hear about us?</h2>
          </div>

          <div class="grid w-full">
            <div *ngFor="let option of hearAboutUsOptions" class="col-6 p-2">
              <div
                class="hear-about-card p-3 flex flex-column align-items-center gap-2 cursor-pointer border-1 border-gray-200 border-round hover:border-blue-500 transition-colors transition-duration-200"
                [class.selected]="signupForm.get('hearAboutUs')?.value.includes(option.value)"
                (click)="signupForm.get('hearAboutUs')?.setValue([option.value])">
                <img [src]="option.icon" [alt]="option.label" style="width: 32px; height: 32px;">
                <span class="text-sm font-medium">{{option.label}}</span>
              </div>
            </div>
          </div>

          <div class="w-full mt-4">
            <p-button label="Create Account" class="w-full sub_style" [loading]="isAccountCreating"
              [disabled]="signupForm.get('hearAboutUs')?.invalid || isAccountCreating" (onClick)="onCreateAccount()" />
          </div>

        </div>
      </div>
      <!-- <div class="w-full" *ngIf="!isSocialAuth" >
        <div class="w-full">
          <p-divider layout="horizontal" [align]="'center'">
            <b class="text-gray-400">OR</b>
          </p-divider>
        </div>
        <div class="w-full flex justify-content-center p-6">
          <app-social-login loginType = 'signUp' class="w-full"></app-social-login>
        </div>
      </div> -->
    </form>
  </div>
</div>